import FlexWrapper from '../../FlexWrapper';
import DateRangeToggle from './DateRangeToggle';
import AnalyticsExportButton from './AnalyticsExportButton';

const AnalyticsHeader = ({ children, dateRanges, setTimeFrame, timeFrame, mb, mt, exportData, exportHeaders, exportFilename, exportLoading }) => {

	const displayTimeFrame = (time) => {
		if (!time || typeof time === "string") {
			return "All Time"
		} else {
			let string = `${time.months ? time.months + " Months" : ""} ${time.days ? time.days + " Days" : ""} ${time.years ? time.years + " Years" : ""}`
			return string
		}
	}

	const hasExport = exportHeaders && exportFilename;

	return (
		<FlexWrapper className={`analytics-header mb-${mb ? mb : "l"}${mt ? " mt-" + mt : ""}`} fullWidth justify="space-between">
			<p className="font-weight-semi-bold">{children}</p>
			<FlexWrapper gap="s">
				{dateRanges && <DateRangeToggle value={displayTimeFrame(timeFrame)} onChange={setTimeFrame} dateRanges={dateRanges} />}
				{hasExport && (
					<AnalyticsExportButton
						headers={exportHeaders}
						data={exportData}
						filename={exportFilename}
						loading={exportLoading}
					/>
				)}
			</FlexWrapper>
		</FlexWrapper>
	);
}

export default AnalyticsHeader;
